/* eslint-disable @typescript-eslint/no-unsafe-return */
import { useState } from 'react'
import { handleError } from '@velasca/utils/handle-error'

export const useSessionStorage = <T>(
  keyName: string,
  defaultValue: string,
): [T, (newValue: T) => void] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const value = window.sessionStorage.getItem(keyName)

      if (value) {
        const parsedValue = JSON.parse(value)

        return parsedValue
      }
      window.sessionStorage.setItem(keyName, JSON.stringify(defaultValue))

      return defaultValue
    } catch (error) {
      handleError(error)

      return defaultValue
    }
  })

  const setValue = (newValue: T) => {
    try {
      window.sessionStorage.setItem(keyName, JSON.stringify(newValue))
    } catch (error) {
      handleError(error)
    }
    setStoredValue(newValue)
  }

  return [storedValue, setValue]
}
